// import React, { useState, useEffect } from "react";
// import "./managescan.css";
// import Table from "react-bootstrap/Table";
// import Axios from "axios";

// function Managescan() {
//   const [data, setData] = useState([]);
//   const [dataa, setDataa] = useState([]);

//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getApproveDPO").then((response) => {
//       setData(response.data);
//     });
//   }, []);

//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getship").then((response) => {
//       const latest30Data = response.data;
//       setDataa(latest30Data);
//     });
//   }, []);

//   const filteredData = data.filter((row) => {
//     return (
//       row.dispatchthrough === "Shivalik Enterprises" &&
//       dataa.some((shipment) => {
//         return (
//           shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
//           shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
//         );
//       })
//     );
//   });

//   return (
//     <div>
//       <label className="managescandata">
//         <h5>Manage Scan Data</h5>
//       </label>
//       <br />
//       <Table className="managescandatashi">
//         <thead>
//           <tr>
//             <th>Order ID</th>
//             <th>Distributor Name</th>
//             <th>Dispatch Through</th>
//             <th>SKU</th>
//             <th>Title</th>
//             <th>Medium</th>
//             <th>Edition</th>
//             <th>Scan Data</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredData.map((row, index) => (
//             <tr key={index}>
//               <td>{row.shipmentid}</td>
//              <td>{row.distributorName}</td>
//               <td>{row.dispatchthrough}</td>
//               <td>
//                 {row.updatedQuantity.map((quantityData, idx) => (
//                   <div key={idx}>
//                     <td>{quantityData.sku}</td>
//                     <td>{quantityData.userDefinedSKU}</td>
//                   </div>
//                 ))}
//               </td>

//               <td>
//                 {row.updatedQuantity.map((quantityData, idx) => (
//                   <div key={idx}>
//                     <td>{quantityData.title}</td>
//                     <td>{quantityData.userDefinedtitle}</td>
//                   </div>
//                 ))}
//               </td>

//               <td>
//                 {row.updatedQuantity.map((quantityData, idx) => (
//                   <div key={idx}>
//                     <td>{quantityData.Medium}</td>
//                     <td>{quantityData.userDefinedMedium}</td>
//                   </div>
//                 ))}
//               </td>

//               <td>
//                 {row.updatedQuantity.map((quantityData, idx) => (
//                   <div key={idx}>
//                     <td>{quantityData.edition}</td>
//                     <td>{quantityData.userDefinededition}</td>
//                   </div>
//                 ))}
//               </td>

//               <td>
//                 {dataa.map((shipment) =>
//                   shipment.barcodeData.map((barcode, index) => {
//                     if (
//                       barcode.OrderNum === row.shipmentid ||
//                       barcode.OrderNum === row.Dorderid
//                     ) {
//                       return (
//                         <tr key={index}>
//                           <td>{barcode.count}</td>
//                         </tr>
//                       );
//                     } else {
//                       return null;
//                     }
//                   })
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

// export default Managescan;

import React, { useState, useEffect } from "react";
import "./managescan.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Managescan() {
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [titleFilter, setTitleFilter] = useState('');
  const [filteredData, setFilteredData] = useState([]);
   const [selectedOption, setSelectedOption] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getApproveDPO").then((response) => {
      setData(response.data);
    });
    Axios.get("https://nodei.ssccglpinnacle.com/getship").then((response) => {
      const latest30Data = response.data;
      setDataa(latest30Data);
    });
  }, []);

  useEffect(() => {
    // Filter data based on title
    const filtered = data.filter((row) => {
      return (
        row.dispatchthrough === "Shivalik Enterprises" &&
        dataa.some((shipment) => {
          return (
            shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
            shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
          );
        }) &&
        row.updatedQuantity.some((quantityData) => {
          return quantityData.title.toLowerCase().includes(titleFilter.toLowerCase());
        })
      );
    });
    setFilteredData(filtered);
  }, [data, dataa, titleFilter]);


   useEffect(() => {
    // Filter data based on title and selected distributor name
    const filtered = data.filter((row) => {
      return (
        row.dispatchthrough === "Shivalik Enterprises" &&
        dataa.some((shipment) => {
          return (
            shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
            shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
          );
        }) &&
        row.updatedQuantity.some((quantityData) => {
          return quantityData.title
            .toLowerCase()
            .includes(titleFilter.toLowerCase());
        }) &&
        (selectedOption === "" || row.distributorName === selectedOption)
      );
    });
    setFilteredData(filtered);

    // Calculate total count for the selected distributor
    let count = 0;
    filtered.forEach((row) => {
      dataa.forEach((shipment) => {
        shipment.barcodeData.forEach((barcode) => {
          if (
            (barcode.OrderNum === row.shipmentid ||
              barcode.OrderNum === row.Dorderid) &&
            row.distributorName === selectedOption
          ) {
            count += barcode.count;
          }
        });
      });
    });
    setTotalCount(count);
  }, [data, dataa, titleFilter, selectedOption]);


  const handleFilterChange = (event) => {
    setTitleFilter(event.target.value);
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  
  return (
    <div>
      <label className="managescandata">
        <h5>Manage Scan Data</h5>
      </label>
      <br />
      <label className="yuip">
        <input
          type="text"
          value={titleFilter}
          onChange={handleFilterChange}
          placeholder="Enter Title to Filter"
        />
        <select className="selectmgscan" value={selectedOption} onChange={handleSelectChange}>
          <option value="">Select Distributorname</option>
          {[...new Set(filteredData.map((row) => row.distributorName))].map(
            (distributorName, index) => (
              <option key={index} value={distributorName}>
                {distributorName}
              </option>
            )
          )}
        </select>
      </label>
           <br />
           <label className="yuip"> Total Dispatch : {totalCount}</label>
          <br />

      <Table className="managescandatashi">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Distributor Name</th>
            <th>Dispatch Through</th>
            <th>SKU</th>
            <th>Title</th>
            <th>Medium</th>
            <th>Edition</th>
            <th>Scan Data</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, index) => (
            <tr key={index}>
              <td>{row.shipmentid}</td>
             <td>{row.distributorName}</td>
              <td>{row.dispatchthrough}</td>
              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.sku}</td>
                    <td>{quantityData.userDefinedSKU}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.title}</td>
                    <td>{quantityData.userDefinedtitle}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.Medium}</td>
                    <td>{quantityData.userDefinedMedium}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.edition}</td>
                    <td>{quantityData.userDefinededition}</td>
                  </div>
                ))}
              </td>

              <td>
                {dataa.map((shipment) =>
                  shipment.barcodeData.map((barcode, index) => {
                    if (
                      barcode.OrderNum === row.shipmentid ||
                      barcode.OrderNum === row.Dorderid
                    ) {
                      return (
                        <tr key={index}>
                          <td>{barcode.count}</td>
                        </tr>
                      );
                    } else {
                      return null;
                    }
                  })
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default Managescan;
